import React from "react";

function Icon({ color, viewBox = "0 0 24 24", className = "" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox={viewBox} className={className}>
      <path
        stroke={color || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M16.8 4H20v7.467h-3.2M16.8 11.467L13.6 20h-1.067a1.067 1.067 0 01-1.066-1.067V13.6H6.135a2.133 2.133 0 01-2.056-2.704l1.482-5.333A2.133 2.133 0 017.616 4H16.8v7.467z"
      ></path>
    </svg>
  );
}

export default Icon;
